// can only be used with async functions
// usage example: async function demo() {await sleep(2000)}
export default function sleep(ms) {
  return new Promise(resolve => setTimeout(resolve, ms));
}
